window.Routes = require('generated/routes.js.erb')
